"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_hook_form_1 = require("react-hook-form");
var react_1 = require("react");
var FieldErrorMessage_1 = __importDefault(require("./FieldErrorMessage"));
var utils_1 = require("../utils");
var SelectWrapper = (0, react_1.forwardRef)(function (_a, ref) {
    var variant = _a.variant, name = _a.name, errors = _a.errors, defaultValue = _a.defaultValue, label = _a.label, children = _a.children, rest = __rest(_a, ["variant", "name", "errors", "defaultValue", "label", "children"]);
    var control = (0, react_hook_form_1.useFormContext)().control;
    function classFromVariant(variant) {
        if (variant === void 0) { variant = "lg"; }
        if (variant === "sm") {
            return "tablet:w-fi-sm flex-shrink-0";
        }
        else if (variant === "md") {
            return "tablet:w-fi-md flex-shrink-0";
        }
        else {
            return "tablet:w-fi-lg flex-shrink-0";
        }
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(classFromVariant(variant)), children: [(0, jsx_runtime_1.jsxs)("label", { className: "whitespace-nowrap", children: [label, rest.fieldRequired && "*"] }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: name, defaultValue: defaultValue || "", render: function (_a) {
                    var field = _a.field;
                    return ((0, jsx_runtime_1.jsxs)("select", __assign({}, field, { ref: ref, className: (0, classnames_1.default)("block h-12 w-full bg-fi-bg  border border-fi-border rounded-fi px-1"), children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: (0, utils_1.t)("select") }), children] })));
                } }), (0, jsx_runtime_1.jsx)(FieldErrorMessage_1.default, { errors: errors, name: name })] }));
});
exports.default = SelectWrapper;
